import { IGeneralModel } from "./abstract/igeneralModel.interface";

export class GeneralModel implements IGeneralModel {
    code: string;
    name: string;
    concurrencyStamp: string;
    isEnabled: boolean = true;
    id: number;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/models/general.model.ts